export default {
    //德语
    DiagnosticReport:'Diagnose berichte',
    troubleCode:'Fehlercode',
    time:'Zeit',
    noTItle:'Kontrolle des Herstellers',
    TestReport:'Testbericht',
    VehicleInformation:'Fahrzeuginformationen',
    DataStream:'Datenstrom',
    IMReadiness:'I/M-Bereitschaft',
    Communication:'Kommunikationsprotokoll',
    notFaultCode:'Fehlerfreier Code',
    nodataflow:'Keine ungewöhnlichen Datenströme',
    // 语言
    lang:{
        cn:'chinesisch',
        de:'Deutsch',
        en:'Deutsch',
        es:'Spanisch',
        fr:'Französisch',
        it:'Italienisch',
        ja:'Japanisch',
        ko:'Koreanisch',
        pt:'Portugiesisch'
    },
    PositioningPrompt:'Aktivieren Sie die Standortfunktion, um lokale Preise zu erhalten',
    FaultCode:'Fehlercode',
    AIDiagnosis:'AI-Diagnose',
    AIWait:'KI-Bericht oder automatische Diagnose warten',
    FailedFaultCode:'Fehlercodeinformationen können nicht abgerufen werden',
    AIError:'AI-Analyse fehlgeschlagen',
    more:'mehr',
    StoredCodes:'Code speichern',
    PendingCodes:'Code verarbeiten',
    PermanentCodes:'permanente Kodierung',
    Unknown:'unbekannt',
    ManufacturerControl:'Herstellerkontrolle'
}